import { createContext } from "react";
import AuthReducer from "../Authentication/AuthReducer.ts";

interface UserInformation {
  token: string;
  fullName: string;
  userType: number;
  mobile: number;
  userName: string;
  accessLevel: any;
  id: any;
  // addresses: any
}
interface AuthenticationInterface {
  userInfo: UserInformation;
  isLogged: boolean;
  login: (
    token: string,
    fullName: string,
    userType: number,
    mobile: number,
    userName: string,
    accessLevel: any,
    id: any,
    addresses: any
  ) => void;
  logout: () => void;
  isChecked: boolean;
  refreshAddresses: () => Promise<void>;
}

const AuthenticationContext = createContext<AuthenticationInterface>({
  userInfo: {
    token: "",
    fullName: "",
    userType: -1,
    mobile: 0,
    userName: "",
    accessLevel: [],
    id: null,
    addresses: [],
  },
  isLogged: false,
  login: () => {},
  logout: () => {},
  isChecked: false,
  refreshAddresses: async () => {},
});

// const checkLoginInfo = useCallback(() => {
//   checkLoginInfoApi().then((response: ApiResponse) => {
//     console.log("serverTime serverTime", response);
//     if (+response.status === 1) {
//       let {
//         data,
//         userinfo: { wallet, ...userinfo },
//         serverTime,
//       } = response;
//       let isSuperAdminCookie = Cookies.get("isSuperAdmin");
//       login({
//         id: userinfo.id,
//         firstname: userinfo.fname,
//         lastname: userinfo.lname,
//         mobile: userinfo.mobile,
//         token: data.usertoken,
//         adminpanelkey: data.adminpanelkey,
//         addresses: userinfo.addresses,
//         user_rolls: userinfo.user_rolls,
//         supplier: userinfo.suppliers,
//         wallet: {
//           id: wallet.id,
//           current_inventory: wallet.current_inventory,
//           main_status: wallet.main_status,
//           type: wallet.type,
//         },
//         access_level:
//           isSuperAdminCookie == "true" && isSuperAdminCookie != undefined
//             ? accessLevels(userinfo.user_rolls)
//             : accessLevels([]),
//         gifts: userinfo.gifts,
//         serverTime: Math.ceil(Date.now() / 1000) - serverTime, //اگر عدد مثبت بود ساعت سیستم جلوتر از سرور است و بلعکس
//       });
//       // }
//     } else if (
//       response?.data?.usertoken &&
//       typeof Cookies.get("usertoken") === "undefined"
//     ) {
//       Cookies.set("usertoken", response.data.usertoken, { expires: 7 });
//     }
//     console.log("test admin panel key", Cookies.get("adminpanelkey"));
//     setIsChecked(true);
//   });
// }, [accessLevels, checkLoginInfoApi, setIsChecked, login]);
export default AuthenticationContext;
// account types:
// 1: customer
// 2: tour leader
// 3:حسابدار
// 4:کانتر فروش
// 5:مدیریت کل
// status = -10 suspend
